module.exports = __webpack_public_path__ + "static/lunaphilia-2f4bf0242c70c661a19cc69abb0c0847.jpg";